import styled from 'styled-components';
import { colors, typography, spacing, breakpoints } from '../../styles/theme';

export const SectionContainer = styled.section`
  width: 100%;
  padding: ${spacing['3xl']} ${spacing.lg};
  background-color: ${props => props.$background || colors.neutral.white};

  @media (max-width: ${breakpoints.md}) {
    padding: ${spacing['2xl']} ${spacing.md};
  }
`;

export const InnerContainer = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  width: 100%;
`;

export const Header = styled.div`
  text-align: ${props => props.$align || 'center'};
  margin-bottom: ${spacing['2xl']};

  @media (max-width: ${breakpoints.md}) {
    margin-bottom: ${spacing.xl};
  }
`;

export const Eyebrow = styled.span`
  display: inline-block;
  font-size: ${typography.fontSize.sm};
  font-weight: ${typography.fontWeight.semibold};
  color: ${colors.primary.orange};
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: ${spacing.sm};
`;

export const Title = styled.h2`
  font-size: ${typography.fontSize['3xl']};
  font-weight: ${typography.fontWeight.bold};
  color: ${colors.primary.teal};
  margin: 0 0 ${spacing.xs} 0;

  @media (max-width: ${breakpoints.md}) {
    font-size: ${typography.fontSize['2xl']};
  }
`;

export const Subtitle = styled.p`
  font-size: ${typography.fontSize.lg};
  color: ${colors.neutral.gray600};
  margin: 0;
  line-height: ${typography.lineHeight.relaxed};

  @media (max-width: ${breakpoints.md}) {
    font-size: ${typography.fontSize.base};
  }
`;
